// extracted by mini-css-extract-plugin
export default {"skeleton":"UfnInZYUGzGpeGEfwuBg","skeletonTitle":"ToACLtUdcE5Jpq5ydu3T","skeletonCard":"oVEnIyfdCKPh9xManF9v","placeholderAnimate":"nWZDNph7o_Pk3K1HzNmx"};